import ScrollFunc from "./common/scrollfunc.es6";
import Subpage from "./common/subpage.es6";
import FitVideo from "./common/fitvideo.es6";

const scrollfunc = new ScrollFunc();
const subopage = new Subpage();
const fitvideo = new FitVideo();
